<!-- Outer Wrapper -->
<div class="h-screen flex relative app-scale">
  @if (!isMobileView()) {
    <!-- Sidebar -->
    <aside
      class="fixed top-0 left-0 z-30 w-64 h-full bg-white shadow transform transition-transform duration-300 lg:static lg:translate-x-0"
      [class.-translate-x-full]="!sidebarOpen"
    >
      <div class="pt-8 pb-4 ml-8">
        <a routerLink="/" class="flex items-center">
          <img src="assets/images/logo-small-black.svg" alt="Novaten Logo" class="w-32" />
        </a>
      </div>

      <div class="w-full px-4">
        <p-tieredmenu [model]="menuItems" class="w-full custom-menu"></p-tieredmenu>
      </div>
    </aside>
  }

  <!-- Overlay for mobile -->
  @if (sidebarOpen) {
    <div class="fixed inset-0 z-20 lg:hidden" style="background-color: rgba(0, 0, 0, 0.1)" (click)="sidebarOpen = false"></div>
  }

  <!-- Main Area -->
  <main class="flex-1 flex flex-col overflow-hidden w-full">
    <!-- Top Header -->
    <header class="flex justify-between items-center p-4 border-b bg-white shadow z-10 h-15">
      <!-- Left: Hamburger + Title -->
      <div class="flex items-center gap-4">
        @if (!isMobileView()) {
          <!-- Hamburger Button (nur mobile) -->
          <button class="lg:hidden text-gray-700 focus:outline-none" (click)="sidebarOpen = !sidebarOpen">
            <svg
              class="w-6 h-6"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        }
        <!-- Title -->
        <div class="text-xl font-semibold text-gray-800">
          @if (isEntityFormPage) {
            <a [routerLink]="pageTitleLink" class="hover:underline">{{ pageTitle | transloco }}</a>
          } @else {
            <span>{{ pageTitle | transloco }}</span>
          }
        </div>
      </div>

      <!-- Right: Actions -->
      <div class="flex items-center text-xm scale-60 sm:gap-4 sm:text-base sm:scale-100">
        <app-language class="mr-2 sm:mr-4"></app-language>
        <div class="user text-ellipsis whitespace-nowrap">
          @if (authService.currentUser) {
            <p-megamenu [model]="userProfile" breakpoint="0px" />
          } @else {
            <span>Loading ...</span>
          }
        </div>
      </div>
    </header>

    <!-- Routed Content -->
    <div class="flex-1 p-4 bg-gray-50 overflow-auto">
      <router-outlet></router-outlet>
      <p-confirmDialog [closable]="false"></p-confirmDialog>
    </div>
  </main>
</div>
